import script from "./HTMazeGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTMazeGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTMazeGamePlay.vue?vue&type=style&index=0&id=528cf336&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528cf336"]])

export default __exports__